var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarrier = function SvgCarrier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#carrier_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001B3A",
    d: "M17.276 7.167h-2.5V3.833H3.109c-.917 0-1.667.75-1.667 1.667v9.167H3.11c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5h5c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5h1.667V10.5zm-.417 1.25 1.633 2.083h-3.716V8.417zM5.609 15.5a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834s.833.375.833.834a.836.836 0 0 1-.833.833m1.85-2.5a2.48 2.48 0 0 0-1.85-.833c-.742 0-1.392.325-1.85.833h-.65V5.5h10V13zm8.15 2.5a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834s.833.375.833.834a.836.836 0 0 1-.833.833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "carrier_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.609.5h20v20h-20z"
  })))));
};
export default SvgCarrier;